import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_395: DocMigration = {
  maxSchemaVersion: "0.0.395",
  description: "Move Door operation linework to new SheetGeometryCategory",
  apply(json: any) {
    if (json.viewTemplates) {
      for (const templateId in json.viewTemplates) {
        const template = json.viewTemplates[templateId];
        if (template.categories) {
          const doorsCategoryIndex = template.categories.findIndex((category) => category === "DOORS");
          if (doorsCategoryIndex >= 0) {
            (template.categories as any[]).splice(doorsCategoryIndex, 0, "DOOR_OPERATION_LINEWORK");
          }
          if (template.styleOverrides && template.styleOverrides["DOORS"]) {
            const doorStyle = template.styleOverrides["DOORS"];
            template.styleOverrides["DOOR_OPERATION_LINEWORK"] = { ...doorStyle };
          }
        }
      }
    }

    // clean up old migration that forgot to remove the styleOverrides from doc.verTemplateOverrides
    if (json.viewTemplateOverrides) {
      for (const viewTemplateId in json.viewTemplateOverrides) {
        const viewTemplateOverride = json.viewTemplateOverrides[viewTemplateId];
        if (viewTemplateOverride.styleOverrides) {
          delete viewTemplateOverride.styleOverrides;
        }
      }
    }

    return json;
  },
};

export default migration_0_0_395;
